import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as regularStar } from "@fortawesome/free-regular-svg-icons";
import { useState } from "react";
import {  useSelector } from "react-redux";
import useFetch from './useFetch'



export default function useFavorite(id) {
    let favorites = useSelector(state => state.favorite.favorites);

    let fav = favorites && favorites.length > 0 && favorites.filter(favorite => favorite.product_id === id).length > 0

    const [selected, settselected] = useState(fav)
    const [icon, setIcon] = useState(fav ? faStar : regularStar)

    let token = useSelector(state => state.user.token)

    const { update, del } = useFetch()

    const addFavorite = () => {

        update(`/favorite?token=${token}`, { id }, null, () => {
            setIcon(faStar)
            settselected(!selected)

        })
    }

    const removeFavorite = () => {
        del(`/favorite?token=${token}`, { id }, null, () => {
            setIcon(regularStar)
            settselected(!selected)
           
        })
    }


    return {
        icon,
        selected,
        addFavorite,
        removeFavorite
    }
}